export const initialPalette = {
    id: 0,
    palette: ["FFFBF7", "9CCCCC", "747AAB", "3F7C91", "000033"],
};

export const cardData = [
    {
        title: "accessibility",
        content:
            "Color is subjective. Everyone sees color differently. Keep in mind users with visual impairments when choosing a color scheme. Make sure the text is legible when applying font and background colors.",
    },
    {
        title: "branding",
        content:
            "Colors can influence human behaviors and emotions. Does your brand already have a primary color? If not, look into color psychology to learn more about the traits and emotions that colors are associated with.",
    },
    {
        title: "contrast",
        content:
            "Visual heirarchy is very important when it comes to design. Choose a color scheme with contrasting colors. Contrast draws attention to certain parts of the design. Make those CTA's pop!",
    },
];
